import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as PoiActions from "../../store/actions/Poi";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const PoiDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="PoiBtn"
      uploadUrl="/poi/bulk/onboarding/ack"
      sampleURL="/sample/bulk_poi_onboarding.csv"
      id="PoiModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Poi Onboarding"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(PoiActions.getUploadUrl, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(PoiDashboard);
